import { createContext } from 'react';

export const HamburgerMenuContext = createContext({
    isOpen: false,
    setIsOpen: (_value: boolean) => {},
});
